import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/documents/{referenceType}/{referenceId}/document']['DELETE'];

const deleteUserWorkflowDocument = async ({ userWorkflowId, referenceType, referenceId }: ThisApi['params']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.delete(`/workflows/user-workflows/${userWorkflowId}/documents/${referenceType}/${referenceId}/document`);
  return response.data;
};

export default deleteUserWorkflowDocument;
